export function useDatePicker(props, state) {
    var disabled = props.disabled, readOnly = props.readOnly;
    var onKeyDown = function (event) {
        if (disabled || readOnly) {
            return;
        }
        if (event.key === ' ') {
            event.preventDefault();
            event.stopPropagation();
            state.setOpen(true);
        }
    };
    var onPress = function () {
        state.setOpen(!state.isOpen);
    };
    return {
        groupProps: {
            role: 'group',
            onKeyDown: onKeyDown,
        },
        triggerProps: {
            tabIndex: -1,
            onPress: onPress,
        },
    };
}
